import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Daundtomorgaoncabservice() {



  const cardData =
  {
    keyword: 'Daund to Morgaon Cab Service',
    heading: 'Sanavi Travels: Daund to Morgaon Cab Service',
    headingDescription: 'Sanavi Travels offers reliable Daund to Morgaon Cab Service, providing safe, comfortable, and convenient transportation for pilgrims, families, groups, and corporate travelers visiting the holy Morgaon temple. Our fleet of well-maintained hatchbacks, sedans, SUVs, and luxury cabs ensures smooth rides, air-conditioning, and ample luggage space for a hassle-free journey. With professional chauffeurs, flexible one-way and round-trip cab options, transparent pricing, and 24/7 booking support, Sanavi Travels guarantees punctual, dependable, and stress-free travel. We provide convenient pickup and drop services across Daund, Pune, and nearby areas, making it ideal for religious trips, group travel, family outings, and corporate travel. Choose Sanavi Travels for trusted Daund to Morgaon cab services, delivering comfort, safety, and a seamless travel experience for every journey.',

    top: 'Top Places to Visit in Morgaon with Sanavi Travels',


"topPlaces": [
  {
    "title": "Morgaon Temple (Mayureshwar Temple)",
    "description": "Morgaon Temple, also known as Mayureshwar Temple, is the foremost of the Ashtavinayak Ganapati temples in Maharashtra. Dedicated to Lord Ganesha, it is the starting point for the Ashtavinayak pilgrimage and attracts devotees seeking blessings for prosperity and wisdom."
  },
  {
    "title": "Temple Courtyard and Pooja Halls",
    "description": "The temple complex features spacious courtyards and dedicated pooja halls where rituals and ceremonies are performed daily. Devotees experience spiritual tranquility while participating in the traditional aartis and offerings."
  },
  {
    "title": "Temple Gardens",
    "description": "The well-maintained gardens around Morgaon Temple provide a peaceful environment for devotees to meditate, walk, and enjoy the serene surroundings amidst sacred ambiance."
  },
  {
    "title": "Local Markets and Shops",
    "description": "The markets near Morgaon Temple offer religious items, souvenirs, prasads, and traditional handicrafts. Visitors can purchase items to commemorate their spiritual journey."
  },
  {
    "title": "Morgaon Village Surroundings",
    "description": "The village around the temple offers a glimpse into rural Maharashtrian life, with agricultural fields, traditional homes, and local culture adding to the spiritual experience."
  },
  {
    "title": "Ashtavinayak Pilgrimage Route",
    "description": "Morgaon serves as the first stop in the Ashtavinayak Ganapati pilgrimage. Pilgrims often travel from here to other sacred Ganesh temples in the region, making it a key spiritual hub."
  },
  {
    "title": "Devotee Accommodation Facilities",
    "description": "The temple trust provides dharmashalas and lodging for pilgrims, ensuring a comfortable stay during their spiritual journey and participation in temple rituals."
  },
  {
    "title": "Traditional Festivals and Celebrations",
    "description": "Ganesh Chaturthi and other festivals are celebrated with grandeur at Morgaon Temple, featuring processions, music, and community gatherings that showcase local traditions."
  },
  {
    "title": "Nearby Scenic Trails",
    "description": "The area around Morgaon features small hills and trails that are ideal for short walks, offering a blend of nature and spirituality for visitors."
  },
  {
    "title": "Religious Learning and Guidance Centers",
    "description": "The temple complex includes areas where devotees can learn about Lord Ganesha, Ashtavinayak traditions, and participate in spiritual discourses conducted by priests and scholars."
  }
]
,



"services": [
    {
      "name": "Daund to Morgaon Cabs Service",
      "description": "Daund to Morgaon Cabs Service offers reliable and comfortable transportation for devotees, families, and groups traveling from Daund to the holy Morgaon Ganpati temple. Professional drivers and well-maintained vehicles ensure a safe and smooth journey."
    },
    {
      "name": "Morgaon Cab from Daund",
      "description": "Morgaon Cab from Daund provides dedicated cab services for visiting Morgaon temple. Ideal for one-way or round trips, the service combines comfort, safety, and punctuality for all travelers."
    },
    {
      "name": "AC Cab Daund to Morgaon",
      "description": "AC Cab Daund to Morgaon ensures a comfortable and refreshing ride, especially suitable for long-distance trips, family travel, and group outings. Air-conditioned vehicles guarantee a pleasant journey."
    },
    {
      "name": "Ganpati Darshan Cab",
      "description": "Ganpati Darshan Cab caters to devotees visiting the Ganpati temple in Morgaon. With organized itineraries, professional drivers, and comfortable cabs, it provides a hassle-free religious travel experience."
    },
    {
      "name": "Religious Tour Cab Daund",
      "description": "Religious Tour Cab Daund offers transportation for temple visits, pilgrimages, and spiritual tours including Morgaon. Reliable cabs and experienced drivers ensure a smooth and peaceful journey."
    },
    {
      "name": "Family Cab Morgaon",
      "description": "Family Cab Morgaon is designed for family trips to Morgaon, providing spacious seating, safety features, and a comfortable ride for all family members, making the journey enjoyable and convenient."
    },
    {
      "name": "Affordable Cab Morgaon",
      "description": "Affordable Cab Morgaon provides budget-friendly cab services without compromising comfort or safety. Ideal for families, groups, and individual travelers seeking reliable transportation from Daund to Morgaon."
    },
    {
      "name": "Chauffeur Driven Cab Morgaon",
      "description": "Chauffeur Driven Cab Morgaon ensures a stress-free travel experience with professional drivers handling navigation, traffic, and schedules. Perfect for family trips, pilgrimages, and group travel."
    },
    {
      "name": "Best Cab Daund to Morgaon",
      "description": "Best Cab Daund to Morgaon guarantees high-quality vehicles, punctual service, and professional drivers. Suitable for all types of travel including religious tours, family trips, and group outings."
    },
    {
      "name": "Tourist Cab Morgaon",
      "description": "Tourist Cab Morgaon caters to travelers exploring Morgaon and nearby attractions. Comfortable vehicles, flexible schedules, and experienced drivers ensure a memorable and convenient trip."
    },
    {
      "name": "Online Cab Booking Daund",
      "description": "Online Cab Booking Daund allows travelers to reserve cabs for Morgaon quickly and easily. Instant confirmation, multiple vehicle options, and flexible itineraries simplify planning for families, groups, and devotees."
    },
    {
      "name": "Temple Darshan Cab",
      "description": "Temple Darshan Cab provides organized transportation for visiting Morgaon and other nearby temples. Safe and comfortable vehicles with professional drivers ensure a seamless and enjoyable pilgrimage experience."
    },
    {
      "name": "One Day Trip Cab",
      "description": "One Day Trip Cab offers convenient transportation for day trips from Daund to Morgaon, perfect for devotees and tourists who want a short and hassle-free visit. Professional drivers ensure timely travel."
    },
    {
      "name": "Outstation Cab Daund",
      "description": "Outstation Cab Daund provides long-distance travel options to Morgaon and surrounding regions. Comfortable cabs, experienced drivers, and reliable service ensure safe and enjoyable travel."
    },
    {
      "name": "Morgaon Travel Taxi",
      "description": "Morgaon Travel Taxi offers comprehensive taxi services for trips from Daund to Morgaon, catering to families, groups, and tourists. Combining affordability, comfort, and professionalism, it ensures a smooth journey."
    }
  ],
  "tableData": [
    ["Daund to Morgaon Cabs Service", "Morgaon Cab from Daund"],
    ["AC Cab Daund to Morgaon", "Ganpati Darshan Cab"],
    ["Religious Tour Cab Daund", "Family Cab Morgaon"],
    ["Affordable Cab Morgaon", "Chauffeur Driven Cab Morgaon"],
    ["Best Cab Daund to Morgaon", "Tourist Cab Morgaon"],
    ["Online Cab Booking Daund", "Temple Darshan Cab"],
    ["One Day Trip Cab", "Outstation Cab Daund"],
    ["Morgaon Travel Taxi", "—"]
  ]
,



"whychoose": [
  {
    "WhyChooseheading": "Daund to Morgaon Cab Service with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides reliable and comfortable cab services from Daund to Morgaon, perfect for pilgrimages, family trips, and group travel."
  },
  {
    "WhyChooseheading": "Well-Maintained and Comfortable Cabs",
    "WhyChoosedescription": "Travel in clean, air-conditioned, and regularly serviced cabs for a smooth and relaxing journey from Daund to Morgaon."
  },
  {
    "WhyChooseheading": "Experienced and Professional Drivers",
    "WhyChoosedescription": "Our licensed drivers are courteous, professional, and familiar with the Daund to Morgaon route, ensuring safe and timely travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers upfront pricing for Daund to Morgaon cab services, including fuel, tolls, and driver allowances, with no hidden costs."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available round the clock to assist with bookings, travel queries, and itinerary planning."
  },
  {
    "WhyChooseheading": "Flexible Cab Booking Options",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized cab packages based on your Daund to Morgaon travel requirements."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Daund to Morgaon cab bookings."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide cab services from Daund to Morgaon?',
    answer: 'Yes, Sanavi Travels offers dependable cab services from Daund to Morgaon for family trips, pilgrimages, and group travel.'
  },
  {
    question: 'How can I book a cab from Daund to Morgaon?',
    answer: 'You can book easily through our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of cabs are available for Daund to Morgaon travel?',
    answer: 'Sanavi Travels provides sedans, SUVs, and premium cars suitable for the Daund to Morgaon journey.'
  },
  {
    question: 'Are drivers experienced on the Daund to Morgaon route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the Daund to Morgaon route.'
  },
  {
    question: 'Can I choose custom pickup and drop-off locations?',
    answer: 'Absolutely. You can select your preferred pickup location in Daund and drop-off in Morgaon.'
  },
  {
    question: 'Is the cab service from Daund to Morgaon available 24x7?',
    answer: 'Yes, Sanavi Travels offers round-the-clock cab services to suit your travel schedule.'
  },
  {
    question: 'Are vehicles sanitized before trips?',
    answer: 'Yes, all cabs are thoroughly cleaned and sanitized before every journey.'
  },
  {
    question: 'What payment options are available for cab bookings?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Daund to Morgaon trip.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Sunil Jadhav',
    feedback: 'Booked a cab from Daund to Morgaon. Comfortable journey with a professional driver and excellent service.',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priya Patil',
    feedback: 'Sanavi Travels made our Daund to Morgaon trip smooth and hassle-free. Highly recommend their cab service.',
    rating: 5
  }
];




































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];











const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Daund to Morgaon Cabs Service - Sanavi Travels",
  "description": "Sanavi Travels offers AC and chauffeur-driven cabs from Daund to Morgaon for Ganpati Darshan, family trips, and religious tours. Affordable, reliable, and easy online booking available.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "45"
  }
};





  return (
    <div>
<Helmet>
  <title>
    Daund to Morgaon Cabs Service | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Sanavi Travels offers AC and chauffeur-driven cabs from Daund to Morgaon for Ganpati Darshan, family trips, and religious tours. Affordable, reliable, and easy online booking available."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/178.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Daundtomorgaoncabservice;